import React, { useEffect } from "react";
import { Typography, Box, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Loader from "./../../components/Loader";
import QRCode from "react-qr-code";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { copyToClipboard } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function QrPopup({ open, handleClose, params, value }) {
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const [copied, setCopied] = React.useState(null);
  const handleCopy = (data) => {
    setCopied(copyToClipboard(data));
    setTimeout(() => {
      setCopied(null);
    }, 1000);
  };
  useEffect(() => {}, [copied]);
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => handleClose()}
        PaperProps={{
          sx: {
            // backgroundColor: "#1E1E1E",
            // backgroundColor: "#171515",
            background: "#171515",
          },
        }}
      >
        <DialogContent sx={{ paddingTop: ".5rem !important" }}>
          <Box
            sx={{
              height: "max-content",
              padding: "1rem",
              maxWidth: "270px",
              margin: "auto",
            }}
          >
            <Typography align="center">{t("qrPopup.text1")}</Typography>
            <Box sx={{ marginTop: "1rem", textAlign: "center" }}>
              <QRCode
                value={`${params["walletId"]}`}
                bgColor="#000000"
                fgColor="yellow"
                size={180}
              />
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <Typography align="left" variant="h6">
                {t("qrPopup.text2")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "5px",
                  borderRadius: "4px",
                  border: "1px solid",
                }}
              >
                <Typography sx={{ wordBreak: " break-all" }}>
                  {value === "hbar" ? params["hbar"] : params["usdc"]}
                </Typography>
                <Tooltip
                  title={copied == null ? "" : t("qrPopup.tooltip")}
                  leaveDelay={1000}
                >
                  <ContentCopyOutlinedIcon
                    className="_cp"
                    onClick={() =>
                      handleCopy(
                        value === "hbar" ? params["hbar"] : params["usdc"]
                      )
                    }
                  >
                    Outlined
                  </ContentCopyOutlinedIcon>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <Typography align="left" variant="h6">
                {t("qrPopup.text4")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "5px",
                  borderRadius: "4px",
                  border: "1px solid",
                  backgroundColor: "#ffffff",
                }}
              >
                <Typography color="secondary">{params["walletId"]}</Typography>
                <Tooltip
                  title={copied == null ? "" : "Copied"}
                  leaveDelay={1000}
                >
                  <ContentCopyIcon
                    className="_cp"
                    onClick={() => handleCopy(`${params["walletId"]}`)}
                    color="secondary"
                  ></ContentCopyIcon>
                </Tooltip>
              </Box>
              <Box sx={{ marginTop: "1rem" }}>
                <Typography
                  color="primary"
                  className="fs-14"
                  sx={{ textAlign: "justify" }}
                >
                  {t("qrPopup.text5")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {loading ? <Loader /> : null}
    </div>
  );
}
